import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
const before = ['You spend every Sunday rebuilding the same lesson from scratch', 'Students tune out because nothing grabs their attention', 'Your materials are scattered across folders, drives and sticky notes', "You explain the same concept ten times and they still don't get it", 'Labs feel stressful, unstructured and hard to manage', 'Your classroom looks outdated compared to what students see everywhere else', 'You end every Friday more exhausted than when the week started'];
const after = ['You walk in Monday with everything printed and ready to go', 'Students are writing, drawing, thinking — actually doing Chemistry', 'Every worksheet, lab guide and assessment lives in one organized, printable system', 'Visual summaries and guided activities do the teaching for you', 'Every lab comes with safety checklists, clear protocols and ready-to-use data sheets', 'Your classroom looks and feels like a premium learning environment', 'You close every Friday knowing next week is already handled'];
export function PainSection() {
  return <section className="w-full bg-paper px-5 py-12 sm:py-20" data-id="element-137" data-mp="5fsr0p8luzeb">
      <div className="mx-auto max-w-5xl" data-id="element-138" data-mp="5f192h7xl06i">
        <div className="mx-auto max-w-2xl text-center" data-id="element-139" data-mp="gzfv3gsjkhb">
          <h2 className="font-serif-display text-2xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-140" data-mp="hiwmgupg2tr">
            Does any of this sound like your week?
          </h2>
          <p className="mt-3 text-sm italic text-cobalt-deep sm:text-base" data-id="element-141" data-mp="33y7wjjzs8eag">
            If even one line hits, this system was built for you.
          </p>
        </div>

        <div className="mt-10 grid gap-6 md:grid-cols-2" data-id="element-142" data-mp="3dvw1t3v0l46v">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.5
        }} className="rounded-2xl border-l-4 border-red-300 bg-[#FFF5F5] p-6 sm:p-8" data-id="element-143" data-mp="3dub6vd4sfj8h">
            <h3 className="mb-5 text-lg font-bold text-ink sm:text-xl" data-id="element-144" data-mp="p3k3o1yaqs0i">Without the system</h3>
            <ul className="space-y-3" data-id="element-145" data-mp="u12e5wrypfam">
              {before.map(item => <li key={item} className="flex items-start gap-3" data-id="element-146" data-mp="yuwucq8czc4y">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-100 text-red-500" data-id="element-147" data-mp="12vqinkppqsyd">
                    <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-148" data-mp="669dr7yk1axq" />
                  </span>
                  <span className="text-sm leading-relaxed text-ink/80" data-id="element-149" data-mp="b4u3uek3ee8g">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="rounded-2xl border-l-4 border-cobalt bg-[#EEF4FF] p-6 sm:p-8" data-id="element-150" data-mp="k4h8rac16269">
            <h3 className="mb-5 text-lg font-bold text-cobalt-deep sm:text-xl" data-id="element-151" data-mp="25o2qx6lqbft5">
              With Visual Chemistry Master System™
            </h3>
            <ul className="space-y-3" data-id="element-152" data-mp="20qt500xjtma2">
              {after.map(item => <li key={item} className="flex items-start gap-3" data-id="element-153" data-mp="1vwgj7k8lnyv5">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-cobalt/15 text-cobalt-deep" data-id="element-154" data-mp="1rwxvyhtb3bp5">
                    <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-155" data-mp="1mywd9xzslee7" />
                  </span>
                  <span className="text-sm leading-relaxed text-ink/80" data-id="element-156" data-mp="1hwnnfai7usgb">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}